import BusinessService from "@/services/business.service"

const initialState = { tiposIngreso: [],
                       listaProductos: [],
                       coupons: [] };

export const business = {
    namespaced: true,
    state: initialState,
    actions: {
        async getCoupons({ commit }) {
            const coupons = await BusinessService.getCoupons();
            commit('successCoupons', coupons);
        },
        async updateCoupon({ dispatch }, { id, couponDTO }) {
            await BusinessService.updateCoupon(id, couponDTO);
            return await dispatch('getCoupons');
        },
        async getTiposIngreso({ commit }, appId) {
            const tiposIngreso = await BusinessService.getTiposIngreso(appId);
            commit('successTi', tiposIngreso);
        },
        async insertProducto({ commit }, req) {
            const nuevoProducto = await BusinessService.insertProducto(req);
            commit('successInsertProducto', nuevoProducto);
        },
        async getProductos({ commit }, userId) {
            const listaProductosUsuario = await BusinessService.listaProductos(userId);
            commit('successProductos', listaProductosUsuario);
        },
        async deleteProducto({ commit }, productoId) {
            await BusinessService.deleteProducto(productoId);
            commit('deleteFromProductos', productoId);
        }
    },
    mutations: {
        successCoupons(state, couponsResponse) {
            state.coupons = couponsResponse;
        },
        successTi(state, tiposIngresoResponse) {
            state.tiposIngreso = tiposIngresoResponse;
        },
        successInsertProducto(state, nuevoProducto) {
            state.listaProductos.push(nuevoProducto);
        },
        successProductos(state, listaProductos) {
            state.listaProductos = listaProductos;
        },
        deleteFromProductos(state, productoId) {
            state.listaProductos = state.listaProductos.filter(obj => obj.id != productoId)
        }
    },
    getters: {
        getTiposIngreso(state){
            return state.tiposIngreso;
        },
        getProductos(state) {
            return state.listaProductos;
        },
        getCoupons(state) {
            return state.coupons;
        }
    }
}